<div class="popup-comp">
  <div class="modal-header">
    <h4 class="modal-title" id="sanofiModalLabel" ngbAutofocus>
      {{ popup_title }}
    </h4>
  </div>

  <div class="modal-body body-style">
    <p [innerHTML]="popup_content"></p>
    <p *ngIf="continueCancelButtons">Time remaining: {{formattedTime}}</p>
  </div>

  <div class="modal-footer">
    <div class="undo-changes-btngrps" *ngIf="!continueCancelButtons">
      <button
        type="button"
        class="btn btn-secondary btn-default cancel-btn"
        (click)="closePopup()">
        Close
      </button>
    </div>
    <div class="undo-changes-btngrps" *ngIf="continueCancelButtons">
      <button type="button" class="btn btn-default blue-button btn-primary mb-2" (click)="emitResponse('extend')">
        Continue
      </button>
      <button type="button" class="btn btn-default btn-secondary" (click)="emitResponse('cancel')">
        Cancel
      </button>
    </div>
  </div>
</div>